
import { useState } from 'react';
import { 
  Box, 
  TextField, 
  Grid, 
  Card, 
  CardContent, 
  CardMedia, 
  Typography, 
  Container, 
  InputAdornment,
  Chip,
  Stack
} from '@mui/material';
import { Search, AccessTime, Person } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { blogPosts, blogCategories } from '../../data/blogData';

export default function AllBlogs() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  
  const filteredBlogs = blogPosts.filter(blog => 
    blog.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (!selectedCategory || blog.category === selectedCategory)
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" gutterBottom align="center" sx={{ mb: 4 }}>
          Time Management Blog
        </Typography>

        <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
          <Chip 
            label="All" 
            onClick={() => setSelectedCategory('')}
            color={selectedCategory === '' ? 'primary' : 'default'}
          />
          {blogCategories.map(category => (
            <Chip 
              key={category}
              label={category}
              onClick={() => setSelectedCategory(category)}
              color={selectedCategory === category ? 'primary' : 'default'}
            />
          ))}
        </Stack>
        
        <TextField
          fullWidth
          placeholder="Search blogs..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ mb: 4 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        
        <Grid container spacing={4}>
          {/* Main content area */}
          <Grid container spacing={3} xs={12} md={8}>
            {filteredBlogs.map(blog => (
              <Grid key={blog.id} xs={12}>
                <Card component={Link} to={`/blog/${blog.slug}`} sx={{ 
                  textDecoration: 'none',
                  display: 'flex',
                  height: '200px'
                }}>
                  <CardMedia
                    component="img"
                    sx={{ width: 200 }}
                    image={blog.image}
                    alt={blog.title}
                  />
                  <CardContent sx={{ flex: 1 }}>
                    <Typography variant="h5" gutterBottom>
                      {blog.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {blog.summary}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Person sx={{ fontSize: 18, mr: 0.5 }} />
                        <Typography variant="caption">{blog.author}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <AccessTime sx={{ fontSize: 18, mr: 0.5 }} />
                        <Typography variant="caption">{blog.readTime} min read</Typography>
                      </Box>
                      <Chip label={blog.category} size="small" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          
          {/* Sidebar */}
          <Grid item md={4}>
            <Box sx={{ 
              bgcolor: 'background.paper',
              p: 2,
              minHeight: 250,
              border: '1px dashed grey',
              textAlign: 'center',
              mb: 3
            }}>
              Ad Space
            </Box>
            
            <Typography variant="h6" gutterBottom>
              Popular Tags
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {Array.from(new Set(blogPosts.flatMap(post => post.tags))).map(tag => (
                <Chip key={tag} label={tag} size="small" />
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
